import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { TableRowDto } from '@asset-metrix/portal-gateway-client-js';
import { Button, Modal } from '@asset-metrix/portal-ui';

import { pixelSizeHelperPortalUi } from '../../utils/pixelSizeHelperPortalUi';

import { InvestmentComplianceLimitDataLevel } from './createInvestmentLimitModel';
import { limitRecordToDraft } from './limitRecordToDraft';
import { ReviewStep } from './ReviewStep';

import styles from './createInvestmentLimitModal.module.scss';

export type ViewInvestmentLimitModalProps = {
  contentId: string;
  dataLevels: InvestmentComplianceLimitDataLevel[];
  onClose: () => void;
  opened: boolean;
  row: TableRowDto['data'];
};

export function ViewInvestmentLimitModal({
  contentId,
  dataLevels,
  onClose,
  opened,
  row,
}: ViewInvestmentLimitModalProps) {
  const { t } = useTranslation();
  const draft = useMemo(
    () => limitRecordToDraft(row as Record<string, unknown>),
    [row]
  );

  return (
    <Modal
      actions={
        <Button variant="secondary" onClick={onClose}>
          {t('app.investmentLimit.close')}
        </Button>
      }
      contentClassName={styles['limit-modal-content']}
      contentHeight="90vh"
      modalType="action"
      opened={opened}
      onClose={onClose}
      size={pixelSizeHelperPortalUi(1200)}
      title={t('app.investmentLimit.viewTitle')}
    >
      <ReviewStep contentId={contentId} dataLevels={dataLevels} draft={draft} />
    </Modal>
  );
}
